<res-base-modal [modalTitle]="modalTitle" [modalAutomationId]="modalAutomationId" [modalClass]="modalClass"
    [modalHelpIndex]="modalHelpIndex" [verifyRequiredValidator]="verifyRequiredValidator"
    [primaryButtonLabel]="primaryButtonLabel" (primaryButtonActionEmt)="ok()" (closeButtonActionEmt)="closeModal()"
    [secondaryButtonLabel]="secondaryButtonLabel" [isPrimaryBtnEnabled]="isPrimaryButtonEnabled()" [(isBusy)]="isBusy"
    [(isBusyMessage)]="isBusyMessage">

    <res-name-description [automationId]="modalAutomationId" [validateName]="validateName"
        [validateNameRequest]="validateNameRequest" [isDescriptionHidden]="isDescriptionHidden"
        [middleRowTemplate]="isDescriptionHidden ? null : colorListTemplate"></res-name-description>

    <ng-template #colorListTemplate>
        <div class="modal-row">
            <div class="modal-row-column-auto"><label [attr.data-automation-id]="modalAutomationId + '-color-label'"
                    for="name" requiredAsterisk>Color:</label></div>
            <div class="modal-row-column-max">
                <ul class="nav nav-tabs">
                    <li *ngFor="let color of colorList; index as i" [ngClass]="{'active': selectedColor === color }"
                        (mousedown)="selectedColor = color" [attr.data-automation-id]="'color-input-' + i">
                        <a><i class="fa" [ngClass]="[editMode > 1 ? 'fa-folder' : 'fa-tag']"
                                [ngStyle]="{color: color}"></i></a>
                    </li>
                </ul>
            </div>
        </div>
    </ng-template>

</res-base-modal>